/**
 * @fileoverview GET handler for the "/apps/catalogs_usage" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsCatalogsUsage } from "./constants";
import type { AppsCatalogsUsageResult } from "./types";

export const getAppsCatalogsUsage = reactQueryFetcherAdapter(
  appsCatalogsUsage,
  (signal: AbortSignal): Promise<AppsCatalogsUsageResult> => {
    return fetch("/apps/catalogs_usage", "GET", {}, { signal });
  }
);
